export const BASELINE_FOR_NON_CRM_SIGNUPS_GATE = 'GrowthOnboardingSetup:BaselineExperienceForNonCrmSignups';